import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {Router} from "@angular/router"

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';

import { MailingModalComponent } from "./modals/mailing.modal.component";

@Component({
    templateUrl: './mailings.component.html',
    styleUrls: [ './mailings.component.scss' ],
})
export class MailingsComponent {

  @ViewChild('mailingModal') 
  public mailingModal: MailingModalComponent;

  public isLoading:boolean = true;

  public rows: any;
  public pager: any = {
    'total': 0, 
    'perPage': environment.itemsPerPage, 
    'page': 1
  };
  public batchActions = [
    { 
      name: 'Zmień nazwę', 
      type: 'icon', 
      icon: 'fa fa-edit', 
      action: (event) => { this.edit(event) } 
    },
    { 
      name: 'Edytuj', 
      type: 'icon', 
      icon: 'fa fa-th', 
      action: (event) => { this.editor(event) } 
    },
    { 
      name: 'Usuń', 
      type: 'icon', 
      icon: 'fa fa-remove', 
      action: (event) => { this.delete(event) } 
    },
  ];
  public columns:Array<any> = [
    {title: 'Nazwa', name: 'nazwa'},
    {title: 'Tytuł PL', name: 'title_pl'},
    {title: 'Tytuł EN', name: 'title_en'},
    {title: 'Utowrzono', name: 'created_at'},
    {title: 'Edit', name: 'batch_actions', actions: this.batchActions },
  ];

  public actions:Array<any> = [
    { title: 'Utwórz nowy', class: 'primary', action: () => this.mailingModal.show(false) }
  ];

  constructor(private http: HttpService, private router: Router) {
    this.loadRows({page: 1});
    this.rows = [];
  }


  public loadRows(event) {
    let page = event.page;
    page = page ? page : 1;

    this.isLoading = true;
    let offset = (page-1)*this.pager.perPage;
    this.http.get(environment.backendUrl+'api/mailing/list/'+offset+'/'+this.pager.perPage)
           .subscribe(
                data => {
                  this.rows = data.json().data;
                  this.pager.total = data.json().count;
                  this.isLoading = false;
                },
                error => setTimeout(this.loadRows, 5000)
           );

  }

  public delete(event) {
    let id = event.target.parentNode.getAttribute('id');
    this.isLoading = true;

    this.http.delete(environment.backendUrl+'api/mailing/'+id)
           .subscribe(
                data => {   
                  this.isLoading = false;
                  this.loadRows({ page: 1 })
                },
                error => setTimeout(this.loadRows, 5000)
           );
  }

  public refreshList(event) {
    this.loadRows(1)
  }

  public tableChanged(page = 1) {
    this.loadRows(page);
  }

  public editor(event) {
    let id = event.target.parentNode.getAttribute('id');
    this.router.navigate(['/editor/'+id+'/pl'])
  }

  public edit(event) {
    let id = event.target.parentNode.getAttribute('id');

    this.http
      .get(environment.backendUrl + 'api/mailing/'+id, '')
      .subscribe(res => {
        this.mailingModal.show(res.json());
      });
  }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/mailings/mailings.component.ts